import { Attributes, List, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';
import LadderLimit from './LadderLimit';

@NeoModel
export default class LadderAge extends ModelBase {
    static typeName = "LadderAge";

    public ladderAgeId: number = 0;

    @Rules.StringLength(50)
    @Rules.Required()
    public description: string = "";

    @Attributes.Integer()
    public daysStart: number = 0;

    @Attributes.Integer()
    @Attributes.Nullable()
    public daysEnd: number | null = 0;

    public ladderLimits = new List(LadderLimit);

    // Client only properties / methods

    @Attributes.NoTracking()
    public isExpanded = false;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
        rules.failWhen(c => c.daysStart < 0, "Start days can't be negative.");
        rules.failWhen(c => c.daysEnd != null && c.daysStart >= c.daysEnd, "Start days should to be less than End days");
    }

    public toString(): string {
        if (this.isNew || !this.description) {
            return "New ladder age";
        } else {
            return this.description;
        }
    }
}